/* eslint-disable react/no-array-index-key */
import { useState } from 'react';
import {
  Collapse, List, ListItemButton, ListItemIcon, ListItemText,
} from '@mui/material';
import { ExpandLess, ExpandMore, ChevronRight } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChildreItemSidebar, ItemSidebar } from '../../../../config/interfaces';
import { setOpenAlertMenu } from '../../../../hooks/actions';

const NavAdminItemChild = (props: {
  item: ItemSidebar
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { item } = props;
  const {
    title,
    child,
    icon,
  } = item;
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const iconIsActive = child && child.find((it: ChildreItemSidebar) => location.pathname.includes(it.href));
  const colorValue = iconIsActive ? '#FEB100' : '#FFF';

  return (
    <>
      <ListItemButton onClick={handleClick}>
        <ListItemIcon>
          {icon(iconIsActive)}
        </ListItemIcon>
        <ListItemText primary={title} sx={{ color: colorValue }} />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {
            child && child.map((it: ChildreItemSidebar, index: number) => (
              <ListItemButton
                onClick={() => {
                  setOpenAlertMenu(false);
                  navigate(`${it.href}`);
                }}
                sx={{ pl: 4 }}
                key={`${title}-${index}`}
              >
                <ListItemIcon>
                  <ChevronRight sx={{
                    color: '#fff',
                  }}
                  />
                </ListItemIcon>
                <ListItemText primary={it.title} />
              </ListItemButton>
            ))
          }
        </List>
      </Collapse>
    </>
  );
}

export default NavAdminItemChild;
